import UserInformationTable from "./UserInformationTable";
import {useContext, useEffect, useState} from "react";
import {toFarsiNumber} from "../cudtom-hooks/en-to-persian";
import {MyContext} from "../context/myContext";
import {useDispatch, useSelector} from "react-redux";
import {selectWaterType, setWaterType} from "../features/request/requestSlice";
import {callApiAgain} from "../features/common-states/commonStatesSlice";

const UserInformation = () => {
    const {bodyArray, title} = useContext(MyContext)
    const [selectedItem, setSelectedItem] = useState('btn2')
    const dispatch = useDispatch()
    const waterType = useSelector(selectWaterType)

    useEffect(() => {
        setSelectedItem(waterType === 1 ? 'btn2' : 'btn1')
    }, [waterType])

    return(
        <div>
            <p className='my-5 text-xs sm:text-sm'>
                <i className="fa fa-angle-double-left mx-1"></i>
                <span>{title}</span>
                <i className="fa fa-angle-double-right mx-1"></i>
            </p>
            {title === 'درخواست های ثبت شده' &&
                <div className='request-toggle mb-3'>
                    <button className={`${selectedItem === 'btn1' ? 'bg-green-500 text-white' : 'bg-white'} border-t border-b border-gray-400 text-[10px] sm:text-xs md:text-sm py-2 px-2 sm:px-10 cursor-pointer border-r-none rounded-l-xl sm:rounded-l-2xl hover:bg-gray-500 hover:text-white`} onClick={() => {dispatch(setWaterType(2)); dispatch(callApiAgain(true))}}>درخواست های شرب دام</button>
                    <button className={`${selectedItem === 'btn2' ? 'bg-green-500 text-white' : 'bg-white'} border-t border-b border-gray-400 text-[10px] sm:text-xs md:text-sm py-2 px-2 sm:px-10 cursor-pointer border-l-none rounded-r-xl sm:rounded-r-2xl hover:bg-gray-500 hover:text-white`} onClick={() => {dispatch(setWaterType(1)); dispatch(callApiAgain(true))}}>درخواست های شرب انسان</button>
                </div>
            }
            <UserInformationTable />
            <p className='text-right text-xs mt-3'>از بین {bodyArray ? toFarsiNumber(bodyArray.length) : 0} مورد</p>
        </div>
    )
}

export default UserInformation